import { createSlice } from "@reduxjs/toolkit";
import {
  generateFollowupQuestions,
  getFollowupQuestions,
  answerFollowupQuestion,
} from "../actions/dynamic-followup-question-actions";

const initialState = {
  byQuestionId: {},
  loadingByQuestionId: {},
  error: null,
};

const upsertItems = (state, questionId, items) => {
  if (questionId == null) return;
  const existing = state.byQuestionId[questionId] || [];
  const map = new Map(existing.map((i) => [i.id, i]));
  items.forEach((i) => map.set(i.id, i));
  state.byQuestionId[questionId] = Array.from(map.values()).sort(
    (a, b) => (a.id || 0) - (b.id || 0)
  );
};

const dynamicFollowupQuestionSlice = createSlice({
  name: "dynamicFollowupQuestion",
  initialState,
  reducers: {
    clearFollowups: (state, action) => {
      const qid = action.payload;
      if (qid == null) {
        state.byQuestionId = {};
      } else {
        delete state.byQuestionId[qid];
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFollowupQuestions.pending, (state, action) => {
        const qid = action.meta.arg.questionId;
        state.loadingByQuestionId[qid] = true;
      })
      .addCase(getFollowupQuestions.fulfilled, (state, action) => {
        const { questionId, items } = action.payload;
        state.loadingByQuestionId[questionId] = false;
        state.byQuestionId[questionId] = items;
      })
      .addCase(getFollowupQuestions.rejected, (state, action) => {
        const qid = action.meta.arg.questionId;
        state.loadingByQuestionId[qid] = false;
        state.error = action.payload;
      })
      .addCase(generateFollowupQuestions.pending, (state, action) => {
        const qid = action.meta.arg.questionId;
        state.loadingByQuestionId[qid] = true;
      })
      .addCase(generateFollowupQuestions.fulfilled, (state, action) => {
        const { questionId, items } = action.payload;
        state.loadingByQuestionId[questionId] = false;
        upsertItems(state, questionId, items);
      })
      .addCase(generateFollowupQuestions.rejected, (state, action) => {
        const qid = action.meta.arg.questionId;
        state.loadingByQuestionId[qid] = false;
        state.error = action.payload;
      })
      .addCase(answerFollowupQuestion.fulfilled, (state, action) => {
        const { questionId, items } = action.payload;
        upsertItems(state, questionId, items);
      });
  },
});

export const { clearFollowups } = dynamicFollowupQuestionSlice.actions;
const dynamicFollowupQuestionSliceReducer = dynamicFollowupQuestionSlice.reducer;
export default dynamicFollowupQuestionSliceReducer;
